module.exports = __webpack_public_path__ + "img/6.01d56ad.png";